'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createActionTypes = exports.createAction = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

/**
 * @fileOverview
 * @author Donny
 */
/**
 * Action生成的语法糖
 * @param  {String} type          [action种类]
 * @return {Object}               [生成的action]
 */
var createAction = exports.createAction = function createAction(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _extends({ type: type }, payload);
};

/**
 * Action type生成的语法糖
 * @param  {String} type          [action种类]
 * @return {Object}               [生成的action]
 */
var PENDING = 'PENDING';
var SUCCESS = 'SUCCESS';
var FAILURE = 'FAILURE';
var RESET = 'RESET';
var createActionTypes = exports.createActionTypes = function createActionTypes(base) {
  return [PENDING, SUCCESS, FAILURE, RESET].reduce(function (actions, type) {
    actions[type] = 'FETCH_' + base + '_' + type;
    return actions;
  }, {});
};

/**
 * Action入参过滤 去掉value为undefined的参数
 * @param  {Object} state         [immutable类型的object]
 * @param  {Object} nextState     [要修改的object]
 * @return {Object}               [新的state]
 */
var nextStateFilter = function nextStateFilter(state, nextState) {
  for (var key in nextState) {
    var value = nextState[key];
    if (value !== undefined) {
      state = state.set(key, value);
    }
  }
  return state;
};

/**
 * !!!!!!!!!! 请不要使用这个 ！！！！！！！！
 * 创建初始state
 * @param {*} defaultState 
 */
var createInitialState = function createInitialState(defaultState) {

  var InitialState = new _immutable.Record(_extends({
    isFetching: false,
    error: undefined,
    created: Date.now()
  }, defaultState));

  return new InitialState();
};

/**
 * !!!!!!!!!! 请使用这个 ！！！！！！！！
 * 创建初始state
 * @param {*} payload  入参
 * @param {*} response  出参
 */
var initState = function initState(payload, response) {
  var Payload = (0, _immutable.Record)(payload);
  var Response = (0, _immutable.Record)(response);
  return {
    isFetching: false,
    payload: new Payload(),
    response: new Response(),
    error: undefined
  };
};

var dataFlow = {
  createAction: createAction,
  createActionTypes: createActionTypes,
  nextStateFilter: nextStateFilter,
  createInitialState: createInitialState,
  initState: initState
};

exports.default = dataFlow;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_alipic-utils@0.0.2@@ali/alipic-utils/lib/dataFlow.js
// module id = 262
// module chunks = 6